<template>
  <div class="col-12 m-0 p-0">
    <div class="col-auto mx-auto text-center">
      <button class="btn btn-outline-info rounded-pill px-3" type="button" @click="show()">
          {{ this.title }}
      </button>
    </div>

    <div class="col-xl-6 offset-xl-4" v-show="display">
      <textarea type="textarea" rows="4" class="form-control mt-3" v-model="text" v-if="!loading">
      </textarea>

      <div v-else class="text-center mt-2">
          <i class="fa fa-spinner fa-pulse fa-fw fa-3x"></i>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "PostTemplatePreview",

  data() {
    return {
      templateText: "",
      text: "",
      display: false,
      loading: true,
    }
  },

  props: {
    selector: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: "Preview Post Design"
    }
  },
    
  methods: {
    show() {
      this.templateText = document.querySelector(this.selector).value;
      this.fetchPreview();
      this.display = true;
    },


    fetchPreview() {
        this.loading = true;
        var self = this;
        axios.get('/api/settings/design/posttemplate/preview', {
            params: {
                template: this.templateText,
            }
        })
        .then(function (response) {
            self.loading = false;
            self.text = response.data;
        })
        .catch(function (error) {
            console.log(error);
        });
    },
  }
};
</script>